export const URL = {
  // dev

  // API_BASE_URL: "http://localhost:4010",
   API_BASE_URL: "https://api.palanhaars.com",
  // API_BASE_URL: "http://192.168.1.9:6001",

  // apipublic
  // API_BASE_URL: "https://api.psf.academy",

  login_admin: "/publicApi/signinAdmin",
  getaddfundListAdmin: "/adminApi/getaddfundListAdmin",
   fundstatusUpdate: "/adminApi/fundstatusUpdate",
  // income
  getlavelincomeAdmin: "/adminApi/getlavelincomeAdmin",
  getDireactncomeAdmin: "/adminApi/getDireactncomeAdmin",
  getBonusIncomeAdmin: "/adminApi/getBonusIncomeAdmin",
  getMatchingIncomeAdmin: "/adminApi/getMatchingIncomeAdmin",
  getReMatchingIncomeAdmin: "/adminApi/getReMatchingIncomeAdmin",
  getReDireactncomeAdmin: "/adminApi/getReDireactncomeAdmin",
  getRelavelincomeAdmin: "/adminApi/getRelavelincomeAdmin",

  // blog

//about
  //about
  createAboutNew: "/adminApi/createAboutNew",
  aboutnewList: "/adminApi/aboutnewList",
  aboutnewDelete: "/adminApi/aboutnewDelete",
  aboutnewUpdate: "/adminApi/aboutnewUpdate",
//
        getaddfundListUser: "/sellerApi/getaddfundListUser",
        

  createBlogs: "/adminApi/createBlogs",
  getBlogList: "/adminApi/getBlogList",
  updateBlogs: "/adminApi/updateBlogs",
  deleteBlog: "/adminApi/deleteBlog",
  // blog

  createBranches: "/adminApi/createBranches",
  getBranchesList: "/adminApi/getBranchesList",
  updateBranches: "/adminApi/updateBranches",
  deleteBranch: "/adminApi/deleteBranch",

  // brand
  updateperentbrand: "/adminApi/updateperentbrand",
  createbrand: "/adminApi/createbrand",
  getBrandList: "/adminApi/getBrandList",
  updateInvoiceProfile: "/adminApi/updateInvoiceProfile",

  createAbout: "/adminApi/createAbout",
  getPagesm: "/adminApi/getpageList",
  updatePageAdmin: "/adminApi/updatePage",
  deletePage: "/adminApi/deletePage",

  // referral
  refferalProgramList: "/adminApi/refferalProgramList",
  ApplyrefferalstatusUpdate: "/adminApi/ApplyrefferalstatusUpdate",

  createFooterPageType: "/adminApi/createFooterPageType",
  footerPageTypesDelete: "/adminApi/footerPageTypesDelete",
  footerPageTypesUpdate: "/adminApi/footerPageTypesUpdate",
  createFooterPageList: "/adminApi/createFooterPageList",

  footerPageTypes: "/adminApi/footerPageTypes",
  getpageListfooter: "/adminApi/getpageListfooter",
  footerPagepageListet: "/adminApi/footerPagepageListet",
  footerPageListsDelete: "/adminApi/footerPageListsDelete",

  updateHomeLogo: "/adminApi/updateHomeLogo",
  updateInvoiceLogo: "/adminApi/updateInvoiceLogo",
  updateLoginLogo: "/adminApi/updateLoginLogo",
  updateRegisterLogo: "/adminApi/updateRegisterLogo",

  addJobCategory: "/adminApi/addJobCategory",
  create_category: "/adminApi/createCategory",
  createAllBranch: "/adminApi/createAllBranch",
  createTearmsAndCondition: "/adminApi/createTearmsAndCondition",
  update_category: "/adminApi/updateperentCate",
  updateperentAllBranchs: "/adminApi/updateperentAllBranchs",
  updateTearmsAndCondition: "/adminApi/updateTearmsAndCondition",
  updateBranchStatusUpdate: "/adminApi/updateBranchStatusUpdate",
  updatejobCate: "/adminApi/updatejobCate",
  delete_category: "/adminApi/deleteCategory",
  deleteAllBranchs: "/adminApi/deleteAllBranchs",
  deleteBrand: "/adminApi/deleteBrand",
  deleteJobCategory: "/adminApi/deleteJobCategory",
  getcateAllList: "/adminApi/getcateAllList",
  getAllBranchsListformain: "/adminApi/getAllBranchsListformain",
  statusCategory: "/adminApi/statusCategory",
  statusAllBranchs: "/adminApi/statusAllBranchs",
  statusTearmsAndCondition: "/adminApi/statusTearmsAndCondition",
  statusBrand: "/adminApi/statusBrand",
  statusJobCategory: "/adminApi/statusJobCategory",

  subcreateSubBranchs: "/adminApi/subcreateSubBranchs",
  subcreateCategory: "/adminApi/subcreateCategory",
  getsubCategoryList: "/adminApi/getsubCategoryList",
  getSubBranchsList: "/adminApi/getSubBranchsList",
  getsubcateAllList: "/adminApi/getsubcateAllList",
  deletesubCategory: "/adminApi/deletesubCategory",
  deleteSubBranchs: "/adminApi/deleteSubBranchs",

  updateperentsubCate: "/adminApi/updateperentsubCate",
  updateperentSubBranchs: "/adminApi/updateperentSubBranchs",
  updateperentsubsubCate: "/adminApi/updateperentsubsubCate",

  subsubcreateCategory: "/adminApi/subsubcreateCategory",
  deletesubsubCategory: "/adminApi/deletesubsubCategory",
  getusercertifiteListAdmin: "/adminApi/getusercertifiteListAdmin",
  getusercertifitedeleteAdmin: "/adminApi/getusercertifitedeleteAdmin",
  getusercertifiteupdateAdmin: "/adminApi/getusercertifiteupdateAdmin",

  statusSubCategory: "/adminApi/statusSubCategory",
  statusSubSubCategory: "/adminApi/statusSubSubCategory",
  vendorPaybleAmountList: "/adminApi/vendorPaybleAmountList",
  vendorPaybleAmountDetails: "/adminApi/vendorPaybleAmountDetails",
  vendorPaybleAmountstatusUpdate: "/adminApi/vendorPaybleAmountstatusUpdate",
  createEducate: "/adminApi/createEducate",
  getDeducateList: "/adminApi/getDeducateList",
  deleteeduCateBtn: "/adminApi/deleteeduCateBtn",
  EditeduCateBtn: "/adminApi/EditeduCateBtn",
  educationAllCreate: "/adminApi/educationAllCreate",
  geteducatetttcate: "/adminApi/geteducatetttcate",
  geteduAllList: "/adminApi/geteduAllList",
  educationstatusUpdate: "/adminApi/educationstatusUpdate",
  educationstatusDelete: "/adminApi/educationstatusDelete",
  examcreate: "/adminApi/examcreate",
  examDeletebyadmin: "/adminApi/examDeletebyadmin",
  getListList: "/adminApi/getexamList",
  getMarqueesList: "/adminApi/getMarqueesList",
  getlevelList: "/adminApi/getlevelList",
  createMarquees: "/adminApi/createMarquees",
  createLeavel: "/adminApi/createLeavel",
  deleteMarquee: "/adminApi/deleteMarquee",
  deleteLevel: "/adminApi/deleteLevel",
  updatemarquseAdmin: "/adminApi/updatemarquseAdmin",
  updateLevelAdmin: "/adminApi/updateLevelAdmin",
  getlistingListAdmin: "/adminApi/getlistingListAdmin",
  updateDynemicBtn: "/adminApi/updateDynemicBtn",

  getFanchiesList: "/adminApi/getFanchiesList",
  users: "/adminApi/getSellerList",
  user_inactive: "/adminApi/getUserListActive",
  getUserIdListActive: "/adminApi/getUserIdListActive",
  getUserListActivedistributor: "/adminApi/getUserListActivedistributor",
  lostfoundActive: "/adminApi/lostfoundActive",
  addFoundByAdmin: "/adminApi/addPoint",
  addPointfr: "/adminApi/addPointfr",
  franceshCreateByAdmin: "/adminApi/franceshCreateByAdmin",
  KycstatusUpdateByAdmin: "/adminApi/KycstatusUpdateByAdmin",
  getUserListseacrch: "/adminApi/searchUserList",
  searchUserListStatus: "/adminApi/searchUserListStatus",
  getSellerListStatus: "/adminApi/getSellerListStatus",
  getSellerListAdminrolevise: "/adminApi/getSellerListAdminrolevise",
  getBettalList: "/adminApi/getBettalList",
  deleteByAdminBettal: "/adminApi/deleteByAdminBettal",
  getBettalListAdmin: "/adminApi/getBettalListAdmin",
  getwithdrwarlAdminList: "/adminApi/getwithdrwarlAdminList",
  completeWithdrawalReq: "/adminApi/completeWithdrawalReq",
  getkycpending: "/adminApi/getkycpending",
  getTransactionList: "/adminApi/getTransactionList",
  getProfileDetails: "/adminApi/getProfileDetails",
  getbDetails: "/adminApi/getbDetails",
  dashboard: "/adminApi/deshBoradData",
  getsetting: "/adminApi/getsetting",
  createSetting: "/adminApi/createSetting",
  deleteUserByadmin: "/adminApi/deleteUserByadmin",
  edituserProfileByadmin: "/adminApi/edituserProfileByadmin",
  edituserKycByadmin: "/adminApi/edituserKycByadmin",
  getctGpg: "/adminApi/getctGpg",
  // addPoint: "/adminApi/addPoint",
  getsubsubCategoryList: "/adminApi/getsubsubCategoryList",

  verifykeyByAdmin: "/adminApi/verifykeyByAdmin",
  categoryWiseSale: "/adminApi/categoryWiseSale",

  user_contact: "/api/user_contact",
  all_category: "/api/all_category",
  all_category_main: "/adminApi/getCategoryList",
  getAllBranchsList: "/adminApi/getAllBranchsList",
  getTearmsAndConditionList: "/adminApi/getTearmsAndConditionList",
  getBranchEnqueryList: "/adminApi/getBranchEnqueryList",
  getJobCategoryList: "/adminApi/getJobCategoryList",

  // product
  getProductList: "/adminApi/getProductList",
  searchProduct: "/adminApi/searchProduct",
  listingProductAdmin: "/adminApi/listingProductAdmin",
  statusProduct: "/adminApi/statusProduct",
  statusFranchiesProduct: "/adminApi/statusFranchiesProduct",
  statuslistingadmin: "/adminApi/statuslistingadmin",
  deletelistingAdmin: "/adminApi/deletelistingAdmin",
  deleteProduct: "/adminApi/deleteProduct",
  productDetails: "/adminApi/productDetails",
  LostFounddeleteadmin: "/adminApi/LostFounddeleteadmin",

  createProduct2: "/adminApi/createProduct2",
  createProductvariations: "/adminApi/createProductvariations",
  updateProductvariations: "/adminApi/updateProductvariations",
  updateProduct: "/adminApi/updateProduct",
  // order
  getuserOrderAdmin: "/adminApi/getuserOrderAdmin",
  getuserOrderAdminfr: "/adminApi/getuserOrderAdminfr",

  getInvoceDetails: "/adminApi/getInvoceDetails",
  getuserOrderDetails: "/adminApi/getuserOrderDetails",
  getuserOrderDetailsfr: "/adminApi/getuserOrderDetailsfr",
  cancelOrderByAdmin: "/adminApi/cancelOrderByAdmin",
  getSearchOrderAdmin: "/adminApi/getSearchOrderAdmin",
  getSearchOrderAdminfr: "/adminApi/getSearchOrderAdminfr",

  getuserreturnOrderAdmin: "/adminApi/getuserreturnOrderAdmin",
  getSearchReturnOrderAdmin: "/adminApi/getSearchReturnOrderAdmin",
  getsubsubcate: "/adminApi/getsubsubcate",

  getmqChalenge: "/adminApi/getmqChalenge",
  getduqeChalenge: "/adminApi/getduqeChalenge",
  MqchalengeUprove: "/adminApi/MqchalengeUprove",
  DuqechalengeUprove: "/adminApi/DuqechalengeUprove",
  ctLeaderBoad: "/adminApi/ctLeaderBoad",

  teamCommissionByDate: "/adminApi/teamCommissionByDate",

  teamCommissionByDateBypagi: "/adminApi/teamCommissionByDateBypagi",
  getTicketList: "/adminApi/getTicketList",
  searchTicket: "/adminApi/searchTicket",
  getmessageSupportList: "/adminApi/getmessageSupportList",
  createMessage: "/adminApi/createMessage",
  addlicence: "/adminApi/addlicence",

  // slider
  createSlider: "/adminApi/createSlider",
  getsliderList: "/adminApi/getsliderList",
  updateSlider: "/adminApi/updateSlider",
  deleteSlider: "/adminApi/deleteSlider",

  // dynrmicbtn
  createDynemicBtn: "/adminApi/createDynemicBtn",
  getDynemicBtnList: "/adminApi/getDynemicBtnList",
  educationallUpdateadmin: "/adminApi/educationallUpdateadmin",
  geteducatetDetails: "/adminApi/geteducatetDetails",
  // updateSlider: "/adminApi/updateSlider",
  deleteDynemicBtn: "/adminApi/deleteDynemicBtn",

  lostfoundlistAdmin: "/adminApi/lostfoundlistAdmin",
  questioncreate: "/adminApi/questioncreate",

  createPackage: "/adminApi/createPackage",
  deletePackage: "/adminApi/deletePackage",
  // deletesubCategory: "/adminApi/deletesubCategory",
  // deletesubsubCategory: "/adminApi/deletesubsubCategory",
  updatePackage: "/adminApi/updatePackage",
  getPackageList: "/adminApi/getPackageList",
  searchPackage: "/adminApi/searchPackage",
  videossubmit: "/adminApi/videossubmit",
  videolistAdmin: "/adminApi/videolistAdmin",
  videodelete: "/adminApi/videodelete",
  questionList: "/adminApi/questionList",
  delete_question: "/adminApi/delete_question",
  update_question: "/adminApi/update_question",
  // product Add

  //

  quiz_list: "/api/quiz_list",
  create_quiz: "/api/create_quiz",
  delete_quiz: "/api/delete_quiz",
  update_quiz: "/api/update_quiz",
  questions_list: "/api/questions_list",

  create_quiz_question: "/api/create_quiz_question",

  user_allcontact: "/api/user_allcontact",

  quiz_active: "/api/quiz_active",

  createcategories: "/apiVendor/createcategories",
  getCategory: "/publicApi/getCategory",

  getsubsubcateHome: "/publicApi/getsubsubcateHome",
  signupSeller: "/publicApi/signupSeller",
  otpVerify: "/publicApi/otpVerify",

  getsellerProductListPublice: "/publicApi/getsellerProductListPublice",
  gettagsProductListPublice: "/publicApi/gettagsProductListPublice",
  getsellerProductListPublicefilCate:
    "/publicApi/getsellerProductListPublicefilCate",
  getsellerProductListPublicebycategory:
    "/publicApi/getsellerProductListPublicebycategory",
  getsellerprofile: "/publicApi/getsellerprofile",
  getfranchiseprofile: "/publicApi/getfranchiseprofile",
  whatsappinquiresubmit: "/publicApi/whatsappinquiresubmit",

  createSubscription: "/publicApi/createSubscription",
  getPages: "/publicApi/getPagesPu",
  emailenquirysubmit: "/publicApi/emailenquirysubmit",
  pageDetails: "/publicApi/pageDetails",
  searchProductpub: "/publicApi/searchProductpub",
  sendOtpSeller: "/publicApi/sendOtpSeller",
  otpVerifyseller: "/publicApi/otpVerifyseller",
  signinSellereSecurite: "/publicApi/signinSellereSecurite",
  footerPagepageListetPu: "/publicApi/footerPagepageListetPu",
  productclick: "/publicApi/productclick",
  getHomePro: "/publicApi/getHomePro",
  getSellerListPublic: "/publicApi/getSellerListPublic",
  getsellerProductListPublicebymaincategory2:
    "/publicApi/getsellerProductListPublicebymaincategory2",

  // apiAdmin
  signinSeller: "/publicApi/signinSeller",
  getsellerProductList: "/sellerApi/getsellerProductList",
  createSellerProduct: "/sellerApi/createSellerProduct",
  searchSellerProduct: "/sellerApi/searchSellerProduct",
  deleteSellerProduct: "/sellerApi/deleteSellerProduct",
  createBussnissPro: "/sellerApi/createBussnissPro",
  getBussProfile: "/sellerApi/getBussProfile",
  updateWhatsaapNumber: "/sellerApi/updateWhatsaapNumber",
  verifyWhatsapp: "/sellerApi/verifyWhatsapp",
  updateBussLogo: "/sellerApi/updateBussLogo",
  updateBussProfile: "/sellerApi/updateBussProfile",
  // getPackageList: "/sellerApi/getPackageList",
  createPurchase: "/sellerApi/createPurchase",
  getsellerTransaction: "/sellerApi/getsellerTransaction",
  getprofile: "/sellerApi/getprofile",
  updatesellerProduct: "/sellerApi/updatesellerProduct",
  getSellerTicketList: "/sellerApi/getSellerTicketList",
  createSellerTickets: "/sellerApi/createSellerTickets",

  // getmessageSupportList: "/sellerApi/getmessageSupportList",

  deleteacountByseller: "/sellerApi/deleteacountByseller",
  copyProduct: "/sellerApi/copyProduct",
  getInvoice: "/sellerApi/getInvoice",
  getEmailenquirySeller: "/sellerApi/getEmailenquirySeller",
  getsellerWhatsappinquire: "/sellerApi/getsellerWhatsappinquire",
  searchtags: "/sellerApi/searchtags",
  passwordChange: "/sellerApi/passwordChange",
  topViewnewSeller: "/sellerApi/topViewnewSeller",
  sellerDashboardState: "/sellerApi/sellerDashboardState",
  getExpireDate: "/sellerApi/getExpireDate",
  // getsliderList: "/publicApi/getsliderList2",
  getBlogListPub: "/publicApi/getBlogListPub",
  getBlogDetails: "/publicApi/getBlogDetails",
  gethomePop: "/publicApi/gethomePop",
  getlistfaqs: "/publicApi/getlistfaqs",
  uploadStateCountryData: "/adminApi/set/locationData",
  getStateCountryData: "/publicApi/get/locationData",
  //success 
  //success
  createSuccess: "/adminApi/createSuccess",
  successList: "/adminApi/successList",
  successDelete: "/adminApi/successDelete",
  successUpdate: "/adminApi/successUpdate",
  //team
   //team
  createTeam: "/adminApi/createTeam",
  teamList: "/adminApi/teamList",
  teamDelete: "/adminApi/teamDelete",
  teamUpdate: "/adminApi/teamUpdate",
   //testominal
  createTestimonial: "/adminApi/createTestimonial",
  testimonialList: "/adminApi/testimonialList",
  testimonialDelete: "/adminApi/testimonialDelete",
  testimonialUpdate: "/adminApi/testimonialUpdate",
  //contact
  // contact
  contactList2: "/adminApi/contactList2",
  enquiryList: "/adminApi/enquiryList",
  contactList: "/adminApi/contactList",
   
  deleteContact: "/adminApi/deleteContact",
 
   //work
  createWork: "/adminApi/createWork",
  workList: "/adminApi/workList",
  workDelete: "/adminApi/workDelete",
  workUpdate: "/adminApi/workUpdate",
     // founder
  createFounder: "/adminApi/createFounder",
  founderList: "/adminApi/founderList",
  FounderUpdate: "/adminApi/FounderUpdate",
  FounderDelete: "/adminApi/FounderDelete",
  //trused
    createTrusted: "/adminApi/createTrusted",
  trustList: "/adminApi/trustList",
  trustUpdate: "/adminApi/trustUpdate",
  trustDelete: "/adminApi/trustDelete",
  //project
   createProjectnew: "/adminApi/createProjectnew",
  projectListNew: "/adminApi/projectListNew",
  projectUpdateNew: "/adminApi/projectUpdateNew",
  projectDeleteNew: "/adminApi/projectDeleteNew",
  //service
  createService: "/adminApi/createService",
  serviceList: "/adminApi/serviceList",
  serviceDelete: "/adminApi/serviceDelete",
  serviceUpdate: "/adminApi/serviceUpdate",

  //service new
    createServiceNew: "/adminApi/createServiceNew",
  servicenewList: "/adminApi/servicenewList",
  servicenewDelete: "/adminApi/servicenewDelete",
  servicenewUpdate: "/adminApi/servicenewUpdate",
  //shorts
  createShorts: "/adminApi/createShorts",
  shortsList: "/adminApi/shortsList",
  shortsDelete: "/adminApi/shortsDelete",
  shortsUpdate: "/adminApi/shortsUpdate",
};

